import { z } from 'zod';
import { createContext } from 'react';

export const Aggregation = z.enum(['average', 'median']);

export type Aggregation = z.infer<typeof Aggregation>;

export const AggregationContext = createContext<Aggregation>('average');
